// extracted by mini-css-extract-plugin
export default {"container":"rectangle-label_container__adXWM","small_view":"rectangle-label_small_view__w8NUs"};